import { render, staticRenderFns } from "./MTabContents.vue?vue&type=template&id=1ca79d1a&"
import script from "./MTabContents.vue?vue&type=script&lang=ts&"
export * from "./MTabContents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports